/**
 * Resolve where a notification should navigate.
 * Receive Money inbox rows store ReceiveMoneyRequestId on referenceId with
 * Type "Transaction" historically — they must open RM details, not retail txn details.
 */

export type NotificationNavItem = {
  id?: string;
  type?: string;
  Type?: string;
  referenceId?: string | number;
  ReferenceId?: string | number;
  referenceNumber?: string | number;
  ReferenceNumber?: string | number;
  description?: string;
  Description?: string;
};

export function isReceiveMoneyNotification(item?: NotificationNavItem | null): boolean {
  if (!item) return false;
  const type = String(item.type ?? item.Type ?? "").trim().toLowerCase();
  if (type === "receivemoney" || type === "receive_money" || type === "receive-money") {
    return true;
  }
  const desc = String(item.description ?? item.Description ?? "").toLowerCase();
  if (desc.includes("receive money")) return true;
  // Payer-abandon copy from CancelReceiveMoneyJourney
  if (desc.includes("payment link is still open")) return true;
  if (desc.includes("without paying") && desc.includes("left the payment")) return true;
  return false;
}

/** Path including optional ?notificationId= for mark-read on the details page. */
export function notificationTargetPath(item?: NotificationNavItem | null): string {
  if (!item) return "/notifications";
  const refId = item.referenceId ?? item.ReferenceId;
  const refNo = item.referenceNumber ?? item.ReferenceNumber;
  const qs = item.id ? `?notificationId=${encodeURIComponent(String(item.id))}` : "";
  const type = String(item.type ?? item.Type ?? "").trim();

  if (isReceiveMoneyNotification(item) && refId != null && String(refId).length > 0) {
    return `/transactions/receive-money/${refId}${qs}`;
  }
  if (type === "Transaction" && refId != null && String(refId).length > 0) {
    return `/transactions/transactiondetails/${refId}${qs}`;
  }
  if (refNo != null && String(refNo).length > 0) {
    return `/support/my-tickets/${refNo}${qs}`;
  }
  return "/notifications";
}
